export const JOB_UNLOCK_PARENT_IDS = {
    // ---- Tier 2 default axis (T1 -> T2) ----
    knight: ['warrior'],
    mage: ['fortune-teller'],
    cleric: ['priest-novice'],
    assassin: ['thief'],
    bowmaster: ['hunter'],
    bard: ['entertainer'],
    // ---- Tier 2 special axis (T1 -> T2) ----
    samurai: ['warrior'],
    summoner: ['fortune-teller'],
    'beast-tamer': ['hunter'],
    'phantom-thief': ['thief'],
    'ascetic-monk': ['priest-novice'],
    // ---- Tier 3 escalator endpoints (T2 -> T3) ----
    paladin: ['knight'],
    archmage: ['mage'],
    'high-priest': ['cleric'],
    ninja: ['assassin'],
    'bow-saint': ['bowmaster'],
    gakusei: ['bard'],
    // ---- Tier 3 cross jobs (T2 + T2 -> T3) ----
    'magus-knight': ['knight', 'mage'],
    valkyrie: ['knight', 'cleric'],
    sage: ['mage', 'cleric'],
    inquisitor: ['cleric', 'assassin'],
    'magic-archer': ['bowmaster', 'mage'],
    'shadow-hunter': ['bowmaster', 'assassin'],
    enchanter: ['mage', 'bard'],
    astrologer: ['mage', 'cleric'],
    'divine-archer': ['bowmaster', 'cleric'],
    spellblade: ['samurai', 'mage'],
    'dragon-knight': ['knight', 'beast-tamer'],
    necromancer: ['mage', 'summoner'],
    druid: ['beast-tamer', 'cleric'],
    trickster: ['phantom-thief', 'bard'],
    'puppet-master': ['summoner', 'bard'],
    'arch-summoner': ['summoner', 'beast-tamer'],
    // ---- Tier 4 legitimate axis (T3 + T3 + T3 -> T4) ----
    'sword-saint': ['magus-knight', 'ninja', 'spellblade'],
    'grand-sage': ['sage', 'archmage', 'high-priest'],
    'astral-archer': ['bow-saint', 'magic-archer', 'arch-summoner'],
    // ---- Tier 4 special axis (T3 + T3 + ... -> T4) ----
    // docs/03 §3.4 leaves dark-lord's third "dark T3" parent unresolved.
    // C1 gates only the two pinned parents; Phase 5.7 owns final authoring.
    'dark-lord': ['necromancer', 'magus-knight'],
    saint: ['high-priest', 'gakusei', 'paladin'],
};
export const MVP_UNLOCK_LEVEL_BY_TIER = {
    2: 5,
    3: 10,
    4: 20,
};
function mvpUnlockFor(job) {
    if (job.tier === 1)
        return undefined;
    const parents = JOB_UNLOCK_PARENT_IDS[job.id];
    if (parents === undefined) {
        throw new Error(`missing MVP unlock parents for job ${job.id}`);
    }
    const requiredLevel = MVP_UNLOCK_LEVEL_BY_TIER[job.tier];
    return {
        requiredJobMaxLevels: Object.fromEntries(parents.map((parentId) => [parentId, requiredLevel])),
    };
}
export function withMvpJobUnlock(job) {
    const unlock = mvpUnlockFor(job);
    return unlock === undefined ? job : { ...job, unlock };
}
//# sourceMappingURL=unlocks.js.map